import BaseComponent from '@blocks/_BaseComponent'




/* LANGUAGE & COUNTRY SWITCH
----------------------------------------------------------------------------------------------------*/

export default class LangSwitch extends BaseComponent {

    constructor($el, namespace) {
        super('LangSwitch', $el, namespace)

        this.isExpanded = false

        this.keydownHandler = (e) => { this.onKeyDown(e) }
        this.focusinHandler = (e) => { this.onFocusIn(e) }

        this.events = [
            [this.$utils.doc, 'layoutChange', () => { this.onResize() }],
            [this.$refs.toggleBtn, 'click', (e) => { this.onToggleClick(e) }],
        ]

        this.on()
    }




    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        //
    }


    onToggleClick(e) {
        e.preventDefault()

        this.toggle()
    }


    onKeyDown({ key }) {
        if (key === 'Escape') {
            this.toggle(false)
        }
    }


    onFocusIn({ target }) {
        if (!this.isExpanded) return

        if (!this.$el[0].contains(target)) {
            this.toggle(false)
        }
    }




    /* Actions
    --------------------------------------------------------- */

    toggle(shouldExpand = !this.isExpanded) {
        if (this.isExpanded === shouldExpand) return

        clearTimeout(this.eventTimer)
        this.$el.toggleClass('is-expanded', shouldExpand)
        this.$refs.toggleBtn.attr('aria-expanded', shouldExpand)


        if (shouldExpand) {
            this.$refs.link[0].focus()
            this.bindListener(this.$utils.doc, 'keydown', this.keydownHandler)

            this.eventTimer = setTimeout(() => {
                this.bindListener(this.$utils.doc, 'focusin', this.focusinHandler)
                this.bindListener(this.$utils.doc, 'click', this.focusinHandler)
            }, 100)
        } else {
            this.unbindListener(this.$utils.doc, 'keydown', this.keydownHandler)
            this.unbindListener(this.$utils.doc, 'focusin', this.focusinHandler)
            this.unbindListener(this.$utils.doc, 'click', this.focusinHandler)
        }

        this.isExpanded = shouldExpand
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



